export const SOUND_OFF_PLAYBACK_TIMEOUT_MS = 4000;

/**
 * Determines whether we should apply the forced cutoff when sound is disabled.
 * Returns true when the audio element either has an unknown duration
 * (cannot guarantee it's short) or exceeds the configured timeout.
 *
 * @param {HTMLMediaElement|null} audioElement - The audio element being evaluated.
 * @param {number} timeoutMs - Maximum duration (ms) allowed when sound is off.
 * @param {(message: string) => void} log - Optional logging function.
 * @returns {boolean}
 */
export const shouldApplySoundOffLimit = (
  audioElement,
  timeoutMs = SOUND_OFF_PLAYBACK_TIMEOUT_MS,
  log = () => {}
) => {
  if (!audioElement) {
    return false;
  }

  const duration = audioElement.duration;
  const limitSeconds = timeoutMs / 1000;

  if (typeof duration !== 'number' || !Number.isFinite(duration) || duration <= 0) {
    log('Sound is off but audio duration unavailable - applying forced cutoff by default');
    return true;
  }

  if (duration <= limitSeconds) {
    log('Sound is off but audio is shorter than cutoff - skipping forced cutoff');
    return false;
  }

  return true;
};

